export default __webpack_public_path__ + "static/Arrieta-00fdd7e99e1d63d96797aacdc0760ae6.jpg";